export { default } from './ShaqbotChatMfe';
